'use client'

import { m, useReducedMotion } from 'motion/react'

/**
 * RuleDraw — vermilion hairline drawn left-to-right on mount.
 *
 * Used above the fold (hero eyebrow) so the page declares its motion
 * vocabulary at first paint without animating the headline itself.
 */
export function RuleDraw({
    className = '',
    delay = 0.1,
}: {
    className?: string
    delay?: number
}) {
    const reduce = useReducedMotion()

    if (reduce) {
        return (
            <span
                aria-hidden
                className={`h-px w-6 bg-vermilion ${className}`}
            />
        )
    }

    return (
        <m.span
            aria-hidden
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
            className={`h-px w-6 origin-left bg-vermilion ${className}`}
            style={{ display: 'inline-block' }}
        />
    )
}
